// SPDX-License-Identifier: GPL-3.0-or-later
// Copyright (C) 2026 Breach Contributors

import DropZone from '@/components/layout/DropZone';

export default function Home() {
  return (
    <div className="flex h-full flex-col items-center justify-center p-8">
      <DropZone />
    </div>
  );
}
